import { VALUATION_PRICE_VS_FAIR_RATIO } from '@/constants/anchors';

export const getButtonLabelBySubSection = (subSection: string) => {
  if (subSection === VALUATION_PRICE_VS_FAIR_RATIO) {
    return 'Screen for companies below fair value';
  }
  return 'Screen for companies with low PE';
};
